import { createBrowserRouter, Navigate  } from "react-router-dom";
import { lazy, Suspense } from "react";
import App from "../../App";
import Animations from "../../components/animation/Animation";
import PrivateRoute from "../PrivateRoute";
import Layout from "../../components/layout/Layout";

const lazyWithDelay = (importFunc, delay) => {
    return new Promise(resolve => {
        setTimeout(() => resolve(importFunc()), delay);
    });
};

const Modulos = lazy(() => lazyWithDelay(() => import('../../pages/modulos/Modulos'), 500));
const ConsultarCliente = lazy(() => import('../../pages/cliente/consultarCliente/ConsultarCliente'));
const CadastrarCliente = lazy(() => import('../../pages/cliente/cadastrarCliente/CadastrarCliente'));

const rotasModulo = createBrowserRouter([
    {
        id: 'app-modulos',
        path: '/',
        element: <App />,
        children: [
            {
                id: 'root',
                path: '',
                element: <Navigate to={'/modulos'} replace={true} />
            },
            {
                id: 'modulos',
                path: '/modulos',
                element: (
                    <Suspense fallback={<Animations />}>
                        <PrivateRoute>
                            <Layout titulo={'Serviços'}>
                                <Modulos />
                            </Layout>
                        </PrivateRoute>
                    </Suspense>
                )
            },
            {
                id: 'consultar-clientes',
                path: '/consultar-clientes',
                element: (
                    <Suspense fallback={<Animations />}>
                        <PrivateRoute>
                            <Layout>
                                <ConsultarCliente />
                            </Layout>
                        </PrivateRoute>
                    </Suspense>
                )
            },
            {
                id: 'cadastrar-cliente',
                path: '/cadastrar-cliente',
                element: (
                    <Suspense fallback={<Animations />} >
                        <PrivateRoute>
                            <Layout>
                                <CadastrarCliente />
                            </Layout>
                        </PrivateRoute>
                    </Suspense>
                )
            }

        ]
    }

]);

export default rotasModulo;